module.exports = __webpack_public_path__ + "img/include.3bd51b95.svg";